import React from 'react';
import { Spinner } from '../Spinner';
import { Stack } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
const overlayLoaderStyles = {
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};
export const OverlayLoader = () => {
  return /*#__PURE__*/_jsx(Stack, {
    styles: overlayLoaderStyles,
    children: /*#__PURE__*/_jsx(Spinner, {})
  });
};